import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';

/**
 * Catch-all route. Before this existed, any unmatched URL — and several links
 * in the footer pointed at unmatched URLs — rendered a completely blank page
 * between the navbar and the footer.
 */
const NotFound = () => (
  <div className="flex min-h-[70vh] items-center justify-center bg-slate-50 px-4 py-24">
    <div className="max-w-md text-center">
      <span className="icon-chip mx-auto h-16 w-16">
        <Compass className="h-8 w-8" />
      </span>
      <p className="mt-6 bg-gradient-to-br from-navy-700 to-navy-400 bg-clip-text font-cormorant text-7xl font-semibold text-transparent">
        404
      </p>
      <h1 className="mt-2 text-3xl">This page could not be found</h1>
      <p className="mt-4 font-montserrat text-sm leading-relaxed text-slate-600">
        The page you are looking for may have moved, or the link may be out of date. If you were
        trying to reach something specific, we are glad to point you to it.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-primary">
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>
        <Link to="/contact" className="btn-secondary">
          Contact us
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
